import React from 'react'
import { Button } from '@material-ui/core';

export const LoginButton = ({ buttonClicked }) => {

  return (
    <div className='loginButtonContainer'>
      <div style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        msTransform: 'translateY(-50%)',
      }}>
        <Button style={{ width: '80px', margin: '0px' }} onClick={buttonClicked} variant='contained'>
          Login
        </Button>
      </div>
    </div >
  )
}
